import { useLocation, matchPath } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";

export const useResponsiveGuardStatus = (): boolean => {
  const {
    context: { featureFlags, responsiveGuardExceptions },
  } = useAppContext();

  const location = useLocation();
  const currentPath = location.pathname;

  const isException = responsiveGuardExceptions.some((pattern) => {
    return matchPath({ path: pattern, end: true }, currentPath);
  });

  if (!featureFlags.enableResponsiveGuard) {
    return false; // Don't show presentation
  }

  return !isException; // true = show slate, false = render children
};
